import { useEffect } from 'react';
import { useFlowEditorContext } from '../../../context';
import { useFlowTestStep } from '../../../../FlowTest/hooks/useFlowTestStep';
import { requiredTestUserDecisionStepTypes } from '../../../types';
import { TEST_NODE_TYPES } from '../../../../FlowTest/testNodeTypes';

export const useCurrentTestStep = ({ stepId }) => {
  const {
    isAutomationTest,
    isAutomationTestInProgress,
    setSelectedNodeId,
    currentTestStepId,
    setCurrentTestStepId,
    currentTestStep,
    examplesRequired,
    setExamplesRequired,
    setIsUserDecisionRequired,
    setIsOpenTestExamplesModal,
    testFlowInstance,
  } = useFlowEditorContext();
  const { testNodeType } = useFlowTestStep({ stepId });

  useEffect(() => {
    if (isAutomationTestInProgress && testNodeType && testNodeType === TEST_NODE_TYPES.inProgress) {
      setSelectedNodeId(stepId);
      setCurrentTestStepId(stepId);
    }
  }, [stepId, isAutomationTestInProgress, setSelectedNodeId, testNodeType, setCurrentTestStepId]);

  useEffect(() => {
    if (isAutomationTest) {
      setExamplesRequired(false);
      setIsUserDecisionRequired(false);
      const typename = currentTestStep?.__typename;
      if (
        isAutomationTestInProgress &&
        currentTestStep?.needsExamplesToTest &&
        testNodeType === TEST_NODE_TYPES.inProgress
      ) {
        setExamplesRequired(true);
        setIsOpenTestExamplesModal(true);
      }
      if (requiredTestUserDecisionStepTypes.includes(typename) && testNodeType === TEST_NODE_TYPES.inProgress) {
        setIsUserDecisionRequired(true);
      }
    }
  }, [
    stepId,
    currentTestStep?.__typename,
    isAutomationTest,
    isAutomationTestInProgress,
    setExamplesRequired,
    setIsOpenTestExamplesModal,
    setIsUserDecisionRequired,
    currentTestStep?.needsExamplesToTest,
    testFlowInstance,
    testNodeType,
  ]);

  return {
    currentTestStep,
    currentTestStepId,
    examplesRequired,
  };
};
